// extracted by mini-css-extract-plugin
module.exports = {"DeleteLink":"SubtypeListRow_DeleteLink__705K9","DropdownMenuIcon":"SubtypeListRow_DropdownMenuIcon__npnjo"};